import { render, staticRenderFns } from "./WorkDetail.vue?vue&type=template&id=2d93d9ea&scoped=true&"
import script from "./WorkDetail.vue?vue&type=script&lang=js&"
export * from "./WorkDetail.vue?vue&type=script&lang=js&"
import style0 from "./WorkDetail.vue?vue&type=style&index=0&id=2d93d9ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d93d9ea",
  null
  
)

/* custom blocks */
import block0 from "./WorkDetail.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAlert,VBtn,VBtnToggle,VCol,VContainer,VIcon,VRow,VSimpleTable,VTooltip})
